import { render, staticRenderFns } from "./fieldset__input--textarea.vue?vue&type=template&id=0ef5adde&lang=pug&"
import script from "./fieldset__input--textarea.vue?vue&type=script&lang=js&"
export * from "./fieldset__input--textarea.vue?vue&type=script&lang=js&"
import style0 from "./fieldset__input--textarea.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports